export default class TouchpointDataLayer {
    constructor(formSelector) {
        this.form = document.querySelector(formSelector);
        this.storageKey = "formDataLayer";

        if (this.form) {
            this.initFormSubmit();
        } else {
            console.error(`❌ Form non trovato con il selettore: ${formSelector}`);
            return;
        }

        this.initThankYouPage();
    }

    /**
     * Inizializza l'evento di submit del form
     */
    initFormSubmit() {
        this.form.addEventListener("submit", (event) => {
            console.log("🔹 Evento submit intercettato");

            let formData = { event: "formSubmit", formID: this.form.id };

            // Itera su tutti i campi del form
            this.form.querySelectorAll("input, select, textarea").forEach(field => {
                if (field.name) {
                    formData[field.name] = field.value || "";
                }
            });

            console.log("📌 Dati raccolti dal form:", formData);

            // Invio al DataLayer
            this.pushToDataLayer(formData);

            // Salvataggio dati nel localStorage
            localStorage.setItem(this.storageKey, JSON.stringify(formData));
            console.log("💾 Dati salvati nel localStorage:", localStorage.getItem(this.storageKey));
        });
    }

    /**
     * Recupera i dati dalla thank you page
     */
    initThankYouPage() {
        console.log("🔍 Controllo se siamo nella thank you page...");
        
        if (document.body.classList.contains("thank-you")) {
            console.log("✅ La pagina è una thank you page!");

            let storedData = localStorage.getItem(this.storageKey);
            if (storedData) {
                console.log("📦 Dati trovati nel localStorage:", storedData);

                let formData = JSON.parse(storedData);

                // Aggiunge evento formSuccess al DataLayer
                this.pushToDataLayer({
                    event: "formSuccess",
                    ...formData
                });

                console.log("🚀 Dati inviati al DataLayer dalla Thank You Page:", formData);

                // Rimuove i dati dal localStorage per evitare duplicazioni
                localStorage.removeItem(this.storageKey);
                console.log("🗑️ Dati rimossi dal localStorage");
            } else {
                console.log("⚠️ Nessun dato trovato nel localStorage!");
            }
        } else {
            console.log("❌ La pagina NON è una thank you page.");
        }
    }

    /**
     * Invia i dati al DataLayer
     * @param {Object} data
     */
    pushToDataLayer(data) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
        console.log("📊 Dati inviati al DataLayer:", data);
    }
}

